<template>
  <div class="kanban-content">
    <div v-for="board of boards" :key="board.id" class="board cursor-pointer" @click="goToBoard(board.id)">
      <div class="name">{{ board.name }}</div>

      <div class="actions">
        <q-btn size="xs" flat round @click.stop="edit(board)">
          <q-icon color="tertiary" name="fas fa-pencil-alt" />
        </q-btn>

        <div class="delete-button">
          <q-btn :disable="board.system" size="xs" flat round @click.stop="deleteClicked(board)">
            <q-icon color="negative" name="fas fa-trash-alt" />
          </q-btn>
          <LmTooltip v-if="board.system">
            This is a system board and cannot be deleted.
          </LmTooltip>
        </div>
      </div>
    </div>

    <BoardDialog ref="dialog" />
  </div>
</template>

<script>
// Components
import BoardDialog from './BoardDialog'
// Libraries
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    BoardDialog
  },

  computed: {
    ...mapState('boards', ['boards'])
  },

  created() {
    const unWatch = this.$watch('boards', val => {
      this.$nextTick(() => {
        if (val) {
          const boards = this.$el.querySelectorAll('.board')
          boards.forEach((el, index) => {
            el.style.animationDelay = `${(index + 1) * 50}ms`
          })
          unWatch()
        }
      })
    })
  },

  methods: {
    ...mapActions('boards', ['deleteBoard']),

    edit(board) {
      this.$refs.dialog.open(board, true)
    },

    deleteClicked(board) {
      this.$q
        .dialog({
          style: 'width: 500px',
          title: 'Are you sure you want to delete the board?',
          message:
            'If there is any todos in it, they will still be displayed in the dashboard, where you can move them to other boards.',
          cancel: true
        })
        .onOk(() => this.deleteBoard(board.id))
    },

    goToBoard(boardId) {
      this.$router.push(`/kanban-boards/${boardId}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

sequentialLoadAnimation()

.kanban-content {
  display grid
  grid-template-columns repeat(auto-fit, minmax(250px, 320px))
  align-items start
  gap 10px

  .board {
    height 100px
    display grid
    grid-template-rows 1fr auto
    padding 10px
    border-radius 5px
    background white
    transition box-shadow 0.1s ease-in
    animation fadeInScaleIn 350ms ease-in-out both;

    &:hover {
      box-shadow 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)
    }

    .actions {
      text-align right

      .delete-button {
        display inline
      }
    }
  }
}
</style>

<style lang="stylus">
.q-dialog__message {
  opacity 1
  font-weight 400
}
</style>
